import { INormalStore } from './interfaces';
import * as actionTypes from './actionTypes';
import { convertTicketNum, getEarliestDate, getAllDatesInDetailData } from '@libs/core';
import { isMobile } from '@libs/globalVariables';
import { scrollToRef } from '@redux/common';

const initialState = {
    NowListID: null,
    NowListData: null,
    DetailData: null,
    ticketNum: null,
    totalAmount: '0',
    TempCalendarData: null,
    pickCalendar: null,
    isDetailLoading: false,
    DetailLoadingFail: false,
    isSessionLoading: false,
    SessionLoadingFail: false,
    calendarErrorMsg: '',
    sessionErrorMsg: '',
    ticketErrorMsg: '',
    Scrollto: null,
    submitWatcher: false,
    isSubmitSuccess: false,
    // 自建
    openNvbRslb: null, // TODO: GDS使用useState控制，要統一改成redux
    allSessions: null,
    disabledSessions: [],
    pickSession: null,
    disabledDateBySession: [],
    minDate: null,
    nullDate: null,
    disabledDate: null,
    soldoutDate: null,
    // normalPlanData: null,
    // hasCalendar: null,
    // hasSession: null,
    ETItemData: null,
    // GDS 
    /* TODO: 如果要開始融合再開啟，不然會跟GDS衝突
    // TODO: 除了session, sessionPicked未取代，其他替換後可刪除
    GNowList: null,
    GNowListData: null,
    GDetail: null,
    session: null,
    sessionPicked: null, //TODO: 等同於自建的pickSession,待融合
    GTempCalendarData: null,
    isGDSDetailLoading: false,
    GDSDetailFetchFail: false,
    isGDSSessionLoading: false,
    GDSSessionFetchFail: false,
    GCalenderErr: '',
    GSessionErr: '',
    GTicketErr: ''
    */
};

const reducer = (state: INormalStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_RESTORE:
            return { ...initialState };
        case actionTypes.SET_RESET:
            const { NowListData, TempCalendarData, DetailData } = state;
            const firstDay = getEarliestDate(getAllDatesInDetailData(DetailData, 'calendarDate')); // 因為EarliestBuyDay改固定，所以抓可選日期的第一天
            const returnState = {
                ...state,
                pickCalendar: NowListData.ExpectedUseDay? firstDay : null,
                calendarErrorMsg: '',
                sessionErrorMsg: '',
                ticketErrorMsg: ''
            };

            // 先確定有無月曆
            const ETItem = NowListData.ExpectedUseDay && firstDay
                ? TempCalendarData[firstDay]?.ETItem
                : DetailData.ETItem;
            
            /*
                再確定有無場次 
                因為自建目前場次尚未移出才需判斷抓取位置(pickSession)
                TODO: 之後改成打場次API後要調整成GDS模式(場次重設會重打API時設定)
            */
            if (!DetailData.Sessions) {
                Object.assign(returnState, { ticketNum: convertTicketNum(ETItem) });
            }else{
                Object.assign(returnState, { 
                    ticketNum: convertTicketNum(ETItem),
                    pickSession: state.allSessions[0] 
                });
            }
            if (isMobile) Object.assign(returnState, { Scrollto: scrollToRef.calender });
            return returnState;
        case actionTypes.SET_NOWLISTID:
            return { ...state, NowListID: action.payload };
        case actionTypes.SET_NOWLISTDATA:
            return { ...state, NowListData: action.payload };
        case actionTypes.SET_DETAILDATA:
            return { ...state, DetailData: action.payload };
        case actionTypes.SET_TICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_TOTALAMOUNT:
            return { ...state, totalAmount: action.payload };
        case actionTypes.SET_TEMPCALENDARDATA:
            return { ...state, TempCalendarData: action.payload };
        case actionTypes.SET_PICKCALENDAR:
            return { ...state, pickCalendar: action.payload };
        case actionTypes.SET_ISDETAILLOADING:
            return { ...state, isDetailLoading: action.payload };
        case actionTypes.SET_DETAILLOADINGFAIL:
            return { ...state, DetailLoadingFail: action.payload };
        case actionTypes.SET_ISSESSIONLOADING:
            return { ...state, isSessionLoading: action.payload };
        case actionTypes.SET_SESSIONLOADINGFAIL:
            return { ...state, SessionLoadingFail: action.payload };
        case actionTypes.SET_CALENDARERRORMSG:
            return { ...state, calendarErrorMsg: action.payload };
        case actionTypes.SET_SESSIONERRORMSG:
            return { ...state, sessionErrorMsg: action.payload };
        case actionTypes.SET_TICKETERRORMSG:
            return { ...state, ticketErrorMsg: action.payload };
        case actionTypes.SET_SCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_SUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_ISSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        // 自建
        case actionTypes.SET_OPENNVBRSLB:
            return { ...state, openNvbRslb: action.payload };
        case actionTypes.SET_ALLSESSIONS:
            return { ...state, allSessions: action.payload };
        case actionTypes.SET_DISABLEDSESSIONS:
            return { ...state, disabledSessions: action.payload };
        case actionTypes.SET_PICKSESSION:
            return { ...state, pickSession: action.payload };
        case actionTypes.SET_DISABLEDDATEBYSESSION:
            return { ...state, disabledDateBySession: action.payload };
        case actionTypes.SET_MINDATE:
            return { ...state, minDate: action.payload };
        case actionTypes.SET_NULLDATE:
            return { ...state, nullDate: action.payload };
        case actionTypes.SET_DISABLEDDATE:
            return { ...state, disabledDate: action.payload };
        case actionTypes.SET_SOLDOUTDATE:
            return { ...state, soldoutDate: action.payload };
        case actionTypes.SET_ETITEMDATA:
            return { ...state, ETItemData: action.payload };
        // GDS
        /* TODO: 如果要開始融合再開啟，不然會跟GDS衝突
        // TODO: 除了GRESTORE, GRESET, session, sessionPicked未取代，其他替換後可刪除
        case actionTypes.SET_GRESTORE: //TODO: 待融合
            return { ...initialState };
        case actionTypes.SET_GRESET: //TODO: 待融合
            const { GNowListData, GTempCalendarData, GDetail, session } = state;
            const returnGState = {
                ...state,
                // calendar: dayjs(GNowListData.EarliestBuyDay).format('YYYY-MM-DD'),
                calendar: dayjs(GDetail.EarliestBuyDay).format('YYYY-MM-DD'),
                GCalenderErr: '',
                GSessionErr: '',
                GTicketErr: '',
            };
            let GETItem;
            if(GNowListData.ExpectedUseDay){
                // 有月曆
                if(GDetail.EarliestBuyDay){
                    GETItem = GTempCalendarData[GDetail.EarliestBuyDay]?.ETItem
                }else{
                    GETItem = GDetail.ETItem;
                }
            }else{
                // 無月曆
                GETItem = GDetail.ETItem;
            }
                
            // console.log("session",session)
            if (!GDetail.Sessions) {
                Object.assign(returnGState, { ticketNum: convertTicketNum(ETItem) });
            }else{
                Object.assign(returnGState, { 
                    ticketNum: convertTicketNum(ETItem),
                    sessionPicked: session[0] 
                });
            }
            return returnGState;
        case actionTypes.SET_CALENDAR:
            return { ...state, calendar: action.payload };
        case actionTypes.SET_GTICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_GSESSION:
            return { ...state, session: action.payload };
        case actionTypes.SET_GSESSIONPICKED:
            return { ...state, sessionPicked: action.payload };
        case actionTypes.SET_GTOTALAMOUNT:
            return { ...state, totalAmount: action.payload };
        case actionTypes.SET_GDETAIL:
            return { ...state, GDetail: action.payload };
        case actionTypes.SET_GTEMPCALENDARDATA:
            return { ...state, GTempCalendarData: action.payload };
        case actionTypes.SET_ISGDSDETAILLOADING:
            return { ...state, isGDSDetailLoading: action.payload };
        case actionTypes.SET_GDSDETAILFETCHFAIL:
            return { ...state, GDSDetailFetchFail: action.payload };
        case actionTypes.SET_ISGDSSESSIONLOADING:
            return { ...state, isGDSSessionLoading: action.payload };
        case actionTypes.SET_GDSSESSIONFETCHFAIL:
            return { ...state, GDSSessionFetchFail: action.payload };
        case actionTypes.SET_GNOWLIST:
            return { ...state, GNowList: action.payload };
        case actionTypes.SET_GNOWLISTDATA:
            return { ...state, GNowListData: action.payload };
        case actionTypes.SET_GCALENDARERR:
            return { ...state, GCalenderErr: action.payload };
        case actionTypes.SET_GSESSIONERR:
            return { ...state, GSessionErr: action.payload };
        case actionTypes.SET_GTICKETERR:
            return { ...state, GTicketErr: action.payload };
        case actionTypes.SET_GSCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_GSUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_ISGSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        */
        default:
            return state;
    }
};

export default reducer;
